import { render, staticRenderFns } from "./SendSlips.vue?vue&type=template&id=bcbf5b4e"
import script from "./SendSlips.vue?vue&type=script&lang=js"
export * from "./SendSlips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports